import { css } from 'styled-components';
const PopupCss = {
    TopLeft: css `
        --Popup_Top: 0;
        --Popup_Y: 0;
        --Popup_Left: 0;
        --Popup_X: 0;
    `,
    Center: css `
        --Popup_Left: 0;
        --Popup_Y: calc(calc(var(--vh, 1vh) * 50) - 50%);
        --Popup_Top: 0;
        --Popup_X: calc(calc(var(--vw, 1vw) * 50) - 50%);
    `,
    SlideInBelow: css `
        --Popup_InitialOffsetY: -0.5rem;
        --Popup_OffsetY: 0;
    `,
    SlideInAbove: css `
        --Popup_InitialOffsetY: 0.5rem;
        --Popup_OffsetY: 0;
    `,
    SlideInAfter: css `
        --Popup_InitialOffsetX: 0.5rem;
        --Popup_OffsetX: 0;
    `,
    Upscale: css `
        --Popup_InitialScale: 0.98;
        --Popup_Scale: 1;
    `,
    NoScale: css `
        --Popup_InitialScale: 1;
        --Popup_Scale: 1;
    `,
    NoOffsetX: css `
        --Popup_InitialOffsetX: 0;
        --Popup_OffsetX: 0;
    `,
    NoOffsetY: css `
        --Popup_InitialOffsetY: 0;
        --Popup_OffsetY: 0;
    `,
    NoOffsetTransition: css `
        --Popup_OffsetTransition: none;
    `,
    Bound: css `
        --Popup_MinXY: var(--Popup_BoundingBoxPadding, 1rem);
        --Popup_MaxX: calc(
            calc(var(--vw, 1vw) * 100) - 100% -
                var(--Popup_BoundingBoxPadding, 1rem)
        );
        --Popup_MaxY: calc(
            calc(var(--vh, 1vh) * 100) - 100% -
                var(--Popup_BoundingBoxPadding, 1rem)
        );
        --Popup_MaxWidth: calc(
            calc(var(--vw, 1vw) * 100) -
                calc(2 * var(--Popup_BoundingBoxPadding, 1rem))
        );
        --Popup_MaxHeight: calc(
            calc(var(--vh, 1vh) * 100) -
                calc(2 * var(--Popup_BoundingBoxPadding, 1rem))
        );
    `,
    NoBorder: css `
        --Popup_Border: 0;
        --Popup_BoxShadow: none;
    `,
    FrostedGlass: css `
        --Popup_BackdropFilter: var(--tv-ui-glass-backdrop-filter);
        --Popup_Background: var(--tv-ui-glass-background);
        --Popup_Color: var(--tv-ui-glass-text-color);
    `,
};
export const PopupCssPreset = {
    Fullscreen: css `
        ${PopupCss.FrostedGlass};
        ${PopupCss.NoBorder};
        ${PopupCss.TopLeft};
        ${PopupCss.NoScale};
        ${PopupCss.NoOffsetX};
        ${PopupCss.NoOffsetY};
        ${PopupCss.NoOffsetTransition};

        --Popup_BorderRadius: 0;
        --Popup_Height: calc(var(--vh, 1vh) * 100);
        --Popup_Width: calc(var(--vw, 1vw) * 100);
    `,
    Center: css `
        ${PopupCss.FrostedGlass};
        ${PopupCss.NoBorder};
        ${PopupCss.Center};
        ${PopupCss.SlideInAbove};
        ${PopupCss.Upscale};
        ${PopupCss.Bound};

        --Popup_BorderRadius: var(--tv-ui-border-radius-2);
        --Popup_Height: auto;
        --Popup_OffsetTransition: initial;
    `,
    AnchoredRight: css `
        ${PopupCss.FrostedGlass};
        ${PopupCss.NoBorder};
        ${PopupCss.NoOffsetY};
        ${PopupCss.SlideInAfter};
        ${PopupCss.Bound};

        --Popup_BorderRadius: var(--tv-ui-border-radius-2);
        --Popup_Height: auto;
        --Popup_OffsetTransition: initial;

        --Popup_Left: 0;
        --Popup_Top: 0;
        --Popup_X: min(
            var(--Popup_MaxX),
            max(
                var(--Popup_MinXY),
                calc(
                    var(--Popup_AnchorX, 0rem) +
                        var(--Popup_AnchorOffset, 0.5rem)
                )
            )
        );
        --Popup_Y: min(
            var(--Popup_MaxY),
            max(var(--Popup_MinXY), calc(var(--Popup_AnchorY, 0rem) - 50%))
        );
    `,
    AnchoredTopCenter: css `
        ${PopupCss.FrostedGlass};
        ${PopupCss.NoBorder};
        ${PopupCss.NoOffsetX};
        ${PopupCss.SlideInAbove};
        ${PopupCss.Bound};

        --Popup_BorderRadius: var(--tv-ui-border-radius-2);
        --Popup_Height: auto;
        --Popup_OffsetTransition: initial;

        --Popup_Left: 0;
        --Popup_Top: 0;

        --Popup_X: min(
            var(--Popup_MaxX),
            max(var(--Popup_MinXY), calc(var(--Popup_AnchorX, 0rem) - 50%))
        );
        --Popup_Y: min(
            var(--Popup_MaxY),
            max(
                var(--Popup_MinXY),
                calc(
                    var(--Popup_AnchorY, 0rem) - 100% -
                        var(--Popup_AnchorOffset, 0.5rem)
                )
            )
        );
    `,
    AnchoredBottomCenter: css `
        ${PopupCss.FrostedGlass};
        ${PopupCss.NoBorder};
        ${PopupCss.NoOffsetX};
        ${PopupCss.SlideInBelow};
        ${PopupCss.Bound};

        --Popup_BorderRadius: var(--tv-ui-border-radius-2);
        --Popup_Height: auto;
        --Popup_OffsetTransition: initial;

        --Popup_Left: 0;
        --Popup_Top: 0;

        --Popup_X: min(
            var(--Popup_MaxX),
            max(var(--Popup_MinXY), calc(var(--Popup_AnchorX, 0rem) - 50%))
        );
        --Popup_Y: min(
            var(--Popup_MaxY),
            max(
                var(--Popup_MinXY),
                calc(
                    var(--Popup_AnchorY, 0rem) +
                        var(--Popup_AnchorOffset, 0.5rem)
                )
            )
        );
    `,
    AnchoredBottomRight: css `
        ${PopupCss.FrostedGlass};
        ${PopupCss.NoBorder};
        ${PopupCss.NoOffsetX};
        ${PopupCss.SlideInBelow};
        ${PopupCss.Bound};

        --Popup_BorderRadius: var(--tv-ui-border-radius-2);
        --Popup_Height: auto;
        --Popup_OffsetTransition: initial;

        --Popup_Left: 0;
        --Popup_Top: 0;

        --Popup_X: min(
            var(--Popup_MaxX),
            max(var(--Popup_MinXY), calc(var(--Popup_AnchorX, 0rem) - 100%))
        );
        --Popup_Y: min(
            var(--Popup_MaxY),
            max(
                var(--Popup_MinXY),
                calc(
                    var(--Popup_AnchorY, 0rem) +
                        var(--Popup_AnchorOffset, 0.5rem)
                )
            )
        );
    `,
    AnchoredBottomLeft: css `
        ${PopupCss.FrostedGlass};
        ${PopupCss.NoBorder};
        ${PopupCss.NoOffsetX};
        ${PopupCss.SlideInBelow};
        ${PopupCss.Bound};

        --Popup_BorderRadius: var(--tv-ui-border-radius-2);
        --Popup_Height: auto;
        --Popup_OffsetTransition: initial;

        --Popup_Left: 0;
        --Popup_Top: 0;

        --Popup_X: min(
            var(--Popup_MaxX),
            max(var(--Popup_MinXY), var(--Popup_AnchorX, 0rem))
        );
        --Popup_Y: min(
            var(--Popup_MaxY),
            max(
                var(--Popup_MinXY),
                calc(
                    var(--Popup_AnchorY, 0rem) +
                        var(--Popup_AnchorOffset, 0.5rem)
                )
            )
        );
    `,
    AnchoredTopRight: css `
        ${PopupCss.FrostedGlass};
        ${PopupCss.NoBorder};
        ${PopupCss.NoOffsetX};
        ${PopupCss.SlideInAbove};
        ${PopupCss.Bound};

        --Popup_BorderRadius: var(--tv-ui-border-radius-2);
        --Popup_Height: auto;
        --Popup_OffsetTransition: initial;

        --Popup_Left: 0;
        --Popup_Top: 0;

        --Popup_X: min(
            var(--Popup_MaxX),
            max(var(--Popup_MinXY), calc(var(--Popup_AnchorX, 0rem) - 100%))
        );
        --Popup_Y: min(
            var(--Popup_MaxY),
            max(
                var(--Popup_MinXY),
                calc(
                    var(--Popup_AnchorY, 0rem) - 100% -
                        var(--Popup_AnchorOffset, 0.5rem)
                )
            )
        );
    `,
};
